export const rolesConfig = {
  admin: ["1263180915715342386", "1248841405019983984"],
  eventsPage: ["1263180915715342386", "1248841405019983984"],
  logsPage: ["1263180915715342386", "1248841405019983984"],
};

export function hasRequiredRole(user, allowedRoles) {
  if (!user || !user.guildRoles) return false;
  return allowedRoles.some((role) => user.guildRoles.includes(role));
}
